export default "__VITE_ASSET__CxkKoqiy__"